// Compare by UTC calendar day: the dates tab renders every date in UTC, so grouping by the
// browser's local day would merge items from different UTC days (e.g. in Germany or India).
function daycmp(a, b) {
  if (a.getUTCFullYear() < b.getUTCFullYear()) { return -1; }
  if (a.getUTCFullYear() > b.getUTCFullYear()) { return 1; }
  if (a.getUTCMonth() < b.getUTCMonth()) { return -1; }
  if (a.getUTCMonth() > b.getUTCMonth()) { return 1; }
  if (a.getUTCDate() < b.getUTCDate()) { return -1; }
  if (a.getUTCDate() > b.getUTCDate()) { return 1; }
  return 0;
}

// item is a date block returned from the API
function isLearnerAssignment(item) {
  return item.learnerHasAccess && item.dateType === 'assignment-due-date';
}

export { daycmp, isLearnerAssignment };
